module.exports = __webpack_public_path__ + "img/wallpaper-sformato-vegetale.90e6c916.png";